<template>
  <button
    class="flex h-8 w-8 shrink-0 bg-white/90 backdrop-blur outline-none items-center justify-center rounded-full text-gray-400 hover:bg-gray-50"
    data-cy-close-dialog
    type="button"
  >
    <app-icon icon="ph:x-bold" :size="18" />
  </button>
</template>
